import React from 'react'
import listhoc from '../Offers/listhoc';
import { orders_api } from '../../actions/http';
import { showOrderDirection, hideOrderDirection, openModal } from '../../actions';
import OrderDueBtn from './orderduebtn';
import usericon from "../../assets/images/user.png";
import LazyImg from '../lazyimg';
import StarRate from './starrating';

const Order = ({id, is_pick_me, pickupdetails, deliverydetails, order_id, status, travel_time, dispatch, paymentdetails, employee_assigned, rating, distance}) => {
    return (
        <div 
            className="order orderhover"
            onMouseEnter={() => dispatch(
                showOrderDirection({
                    pickup: {
                        lat: parseFloat(pickupdetails.latitude),
                        lng: parseFloat(pickupdetails.longitude)
                    },
                    drop : {
                        lat: parseFloat(deliverydetails.latitude),
                        lng: parseFloat(deliverydetails.longitude)
                    }
                })
            )}
            onMouseLeave={() => dispatch(
                hideOrderDirection()
            )}
        >
            <div className="flex-between">
                <div className="tripid">{is_pick_me ? 'Trip' : 'Order'} Id: {order_id}</div>
                <div className={`order-status-${status.id}`}>{status.name}</div>
            </div>
            {
                employee_assigned &&
                <div className="delivery-person-details">
                    <div className="row">
                        <div className="col-md-6  p-b-10">
                            <h5 className="addr-head">Delivery person details</h5>
                            <div className="row">
                                <div className="col-md-2 p-b-10">
                                    <LazyImg className="employeeimg" src={employee_assigned.profile_pic || usericon} alt={employee_assigned.first_name} />
                                </div>
                                <div className="col-md-10  p-b-10">
                                    <div>
                                        <p>{employee_assigned.first_name}</p>
                                        <a className="common-color" href={`tel:${employee_assigned.username}`}>{employee_assigned.username}</a> 
                                    </div>
                                </div>
                            </div>
                        </div>
                       {status.id === 5 && <div className="col-md-6  p-b-10">
                            <h5 className="addr-head">Rate your order</h5>
                            <div className="star-rating">
                                <StarRate id={id} rating={rating} />
                            </div>
                        </div>}
                    </div>
                </div>
            }
            <div className="row m-t-10">
                <div className="col-md-6">
                    <Address heading="Pickup details" address={pickupdetails}/>
                    {status.id !== 5 && <p>Pickup OTP: <span className="font-bold">{pickupdetails.otp}</span></p>}
                </div>
                <div className="col-md-6 dashed-border-left">
                    <Address heading="Drop details" address={deliverydetails}/>
                    {status.id !== 5 && <p>Drop OTP: <span className="font-bold">{deliverydetails.otp}</span></p>}
                </div>
            </div>
            <div className="row m-t-10">
                <div className="col-md-12">
                    <button onClick={() => dispatch(openModal("BILL", paymentdetails))} className="btn btn-link p-0">View Price Details</button>
                </div>
            </div>
            <div className="flex-between m-t-10">
                <div>
                    <span className="m-r-10">ETA: <b>{travel_time}</b></span>
                    <span className="m-r-10">Fare: <b>&#8377;{paymentdetails.total_amount}</b></span>
                    <span className="m-r-10">Paid Amount: <b>&#8377;{paymentdetails.paid_amount}</b></span>
                    <span className="m-r-10">Distance: <b>{distance}km</b></span>
                </div>
                <div>
                    {
                        status.id === 4 && paymentdetails.balance > 0 ?
                        <OrderDueBtn id={id} dueAmount={paymentdetails.balance} /> :
                        null
                    }
                </div>
            </div>
        </div>
    )
}


export const Address = ({address, heading}) => (
    <div>
        <h5 className="addr-head">{heading}</h5>
        <p>{address.name}</p>
        <p>{address.mobile}</p>
        <p>{address.address}</p>
    </div>
)

export const UpcomingOrders = listhoc(Order, "ORDERLIST_UPCOMING" , "orderlist_upcoming", orders_api + `?is_completed=false`);

export const CompletedOrders = listhoc(Order, "ORDERLIST_COMPLETED" , "orderlist_completed", orders_api + `?is_completed=true`);

export default Order
